<template>
  <div class="max-w-screen">
    <AthleteProfileHero />
    <SecondaryBar />

    <div class="w-full p-3 bg-blue-300">
      <FeedbackRequestBar v-if="showFeedbackRequestBar" />
      <template v-else>&nbsp;</template>
    </div>

    <!-- Athlete Stats and Information -->
    <div class="lg:max-w-6xl mx-auto px-3 sm:px-4 md:px-6">
      <AthleteVideos :userId="userId" />
      <AthleteContactInformation :show-message-button="showMessageButton" />
      <AthleteAthletic />
      <AthleteEvents :userId="userId" />
      <AthleteAcademic />
    </div>
  </div>
</template>

<script>
import AthleteProfileHero from "./AthleteProfileHero";
import AthleteVideos from "./ProfileSections/Video/Library.vue";
import AthleteContactInformation from "./ProfileSections/Contact/AthleteContactInformation.vue";
import AthleteAthletic from "./ProfileSections/Athletic/AthleteAthletic.vue";
import AthleteEvents from "./ProfileSections/Events/AthleteEvents.vue";
import AthleteAcademic from "./ProfileSections/Academic/AthleteAcademic.vue";
import SecondaryBar from "./SecondaryBar";
import FeedbackRequestBar from "./FeedbackRequestBar";
import { mapGetters } from "vuex";

export default {
  props: {
    userId: { required: true },
    showMessageButton: {type: Boolean, default: true}
  },
  components: {
    AthleteProfileHero,
    AthleteVideos,
    AthleteContactInformation,
    AthleteAthletic,
    AthleteEvents,
    AthleteAcademic,
    SecondaryBar,
    FeedbackRequestBar,
  },
  computed: {
    ...mapGetters("athleteProfile", ["canSendFeedbackRequest"]),

    showFeedbackRequestBar() {
      return this.canSendFeedbackRequest;
    }
  },
  async mounted() {
    await this.$store.dispatch("athleteProfile/fetchAthlete", this.userId);
    this.$emit("loaded");
  },
};
</script>

<style>
p {
  margin: 0;
}
</style>